export default function ($scope, $uibModalInstance, $filter, courseCode, courseName, current, classes) {

    $scope.courseName = courseName;
    $scope.courseCode = courseCode;

    $scope.validClasses = [];
    $scope.current = [];
    $scope.classTypes = [];

    var uniqueClassNos = [],
        currentClassNos = [],
        toRemove = [];

    function buildUniqueList(initial, parsed, uniqueArray, isCurrentClasses) {
        initial.forEach(c => {
            if (c && (c.enrolmentStatus === 'O' || isCurrentClasses)) {

                var classNo = c.classNo,
                    i = uniqueArray.indexOf(classNo);

                if (i === -1) {
                    c.isMultiday = false;
                    parsed.push(c);
                    uniqueArray.push(classNo);
                } else {
                    parsed[i].isMultiday = true;
                    $scope.hasMultiday = true;
                }

                if ($scope.classTypes.indexOf(c) === -1) {
                    $scope.classTypes.push(c);
                }
            }
        });
    };

    buildUniqueList(current, $scope.current, currentClassNos, true);
    buildUniqueList(classes, $scope.validClasses, uniqueClassNos);

    // make sure no classes exist in valid that are already selected - multidays will still be appearing    
    $scope.validClasses = $scope.validClasses.filter(c => currentClassNos.indexOf(c.classNo) === -1);

    $scope.toAdd = null;
    $scope.SetSelectedClass = t => {
        $scope.toAdd = t;
    }

    $scope.showCurrent = current.length !== 0;

    $scope.markForRemoval = () => {
        toRemove = $scope.current.filter(el =>el.checked);
    }

    $scope.getNgOption = c => 
        !c.isMultiday
            ? `${c.classDesc} (${c.meetingDay}, ${$filter('dateTime')(c.meetingStartTime, 'time')}-${$filter('dateTime')(c.meetingEndTime, 'time')}, ${c.location})`
            : `${c.classDesc} (${c.classSection}) *`;    

    $scope.ok = () => {
        var toAdd = $scope.validClasses.filter(o => (o.classNo.toString() + o.classMeetingNo.toString()) === $scope.toAdd);     
        $uibModalInstance.close([toAdd, toRemove]);
    };

    $scope.cancel = function () {
        resetRemoval();
        $uibModalInstance.dismiss('cancel');
    };

    function resetRemoval() {
        $scope.current.forEach(o => o.checked = false);            
    }
};